module.exports = __webpack_public_path__ + "img/comfortaa-v27-latin-regular.f5aecdbd.svg";